import { useContext } from "react";
import { IndicationContext } from "../../context/IndicationContext";
import { Button, Col, Form, Input, Row, Select } from "antd";
import { statusIndication } from "../../pages/Indication";
import { v4 as uuidv4 } from "uuid";
import { prop } from "cheerio/lib/api/attributes";

const { Option } = Select;
const { TextArea } = Input;

interface IFormIndication {
    setOpen: any;
    cont?: any;
}

export function FormIndication(props: IFormIndication) {
    const { editIndication } = useContext(IndicationContext);

    return (
        <Form
            layout="vertical"
            onFinish={(v: any) => {
                let obj = {
                    ...props.cont,
                    ...v,
                };
                editIndication(obj);
                props.setOpen(false);
            }}
            initialValues={props.cont}
        >
            {props.cont && (
                <Form.Item
                    name="id_form_indication"
                    style={{ display: "none" }}
                >
                    <input type="hidden" name="id_form_indication"></input>
                </Form.Item>
            )}
            <Row gutter={[24, 0]}>
                <Col span={8}>
                    <Form.Item label="Status:" name="status">
                        <Select
                            placeholder="Selecione"
                            disabled={props.cont.status === "finished"}
                        >
                            {statusIndication.map((i: any) => {
                                return (
                                    <Option key={uuidv4()} value={i.id}>
                                        {i.label}
                                    </Option>
                                );
                            })}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={16}>
                    <Form.Item
                        label="Observação:"
                        name="observation"
                        rules={[
                            {
                                required: props.cont.observation !== null,
                                message: "Campo não pode mais ser vazio",
                            },
                            () => ({
                                validator(_, value) {
                                    if (props.cont.observation !== null) {
                                        if (!value) {
                                            return Promise.reject();
                                        }
                                        return Promise.resolve();
                                    }

                                    return Promise.resolve();
                                },
                            }),
                        ]}
                    >
                        <TextArea
                            placeholder="Observação do status da indicação"
                            showCount
                            autoSize={{ minRows: 1 }}
                            maxLength={255}
                            disabled={props.cont.status === "finished"}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <div style={{ marginTop: "20px" }}>
                <Button type="primary" htmlType="submit" block>
                    Salvar
                </Button>
            </div>
        </Form>
    );
}
